export const REQUEST_REFEREES = 'raf/REQUEST_REFEREES';
export const RECEIVE_REFEREES = 'raf/RECEIVE_REFEREES';
export const SET_REFERRER = 'raf/SET_REFERRER';
export const POST_SET_REFERRER = 'raf/POST_SET_REFERRER';
